import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GatewaysComponent } from './gateways.component'
import { AuthGuard } from 'src/app/config/auth.guard';

const routes: Routes = [
    {
        path: 'gateways',
        component: GatewaysComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class GatewaysRoutingModule { }